import React, { useState, useEffect } from "react";
import useBodyScrollLock from "../Hooks/useBodyScrollLock";
import Close from "../Icons/Close";

export default function Modal({ children, closeModal }) {
  const [visible, setVisible] = useState(false);
  useBodyScrollLock(true);

  // paint the component once first before changing the translate property so that the component animates as a pop-up from bottom
  useEffect(() => {
    setVisible(true);
  }, []);

  return (
    <div className="fixed inset-0 z-10 flex flex-col items-center justify-center">
      <button
        className="absolute w-full h-full bg-gray-900 bg-opacity-50"
        onClick={closeModal}
      ></button>
      <div
        className={`relative max-h-full w-full mx-5 md:mx-0 md:w-4/5 lg:w-3/5 overflow-y-auto p-8 bg-white mt-20 transform transition-transform duration-100 ease-in ${
          visible ? "translate-y-0" : "translate-y-screen"
        }`}
      >
        <button
          onClick={closeModal}
          className="absolute top-0 right-0 w-8 h-8 mt-3 mr-3"
        >
          <Close />
        </button>
        {children}
      </div>
    </div>
  );
}
